/*
 * cart-progressbar.js
 * Atualiza a barra de progresso promocional do carrinho lateral.
 *
 * O snippet (snippets/cart-progressbar.liquid) é re-renderizado pelo servidor
 * a cada atualização do carrinho (parcial AJAX cart.ajax_side_cart), trazendo o
 * total atual em data-cart-total. Como o elemento é recriado a cada injeção,
 * connectedCallback recalcula o estado e anima a barra a partir do zero.
 */
(function () {
  if (window.customElements && customElements.get("cart-progressbar")) {
    return;
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents, window.money_format);
    }
    return (cents / 100).toFixed(2);
  }

  class CartProgressbar extends HTMLElement {
    connectedCallback() {
      this.update();
    }

    getCartTotal() {
      var attr = this.getAttribute("data-cart-total");
      var total = parseInt(attr, 10);
      return isNaN(total) ? 0 : total;
    }

    update() {
      var bar = this.querySelector(".progress");
      var dot = this.querySelector(".progress-dot");
      var stepEls = Array.prototype.slice.call(
        this.querySelectorAll(".progress-step")
      );
      if (!bar || !stepEls.length) {
        return;
      }

      var total = this.getCartTotal();

      var steps = stepEls
        .map(function (el) {
          return {
            el: el,
            threshold: parseFloat(el.getAttribute("data-step")) || 0,
            pos: parseFloat(el.getAttribute("data-percentage")) || 0,
            texto: el.getAttribute("data-texto-promocional") || "",
          };
        })
        .sort(function (a, b) {
          return a.threshold - b.threshold;
        });

      // Define o segmento atual e marca as metas já atingidas.
      var prevThreshold = 0;
      var prevPos = 0;
      var next = null;
      steps.forEach(function (step) {
        if (total >= step.threshold) {
          step.el.classList.add("progress-step-active");
          prevThreshold = step.threshold;
          prevPos = step.pos;
        } else {
          step.el.classList.remove("progress-step-active");
          if (!next) {
            next = step;
          }
        }
      });

      // Calcula a fração preenchida (interpolada entre as metas).
      var fraction;
      if (!next) {
        fraction = 1;
      } else {
        var span = next.threshold - prevThreshold;
        var segFrac = span > 0 ? (total - prevThreshold) / span : 0;
        segFrac = Math.min(1, Math.max(0, segFrac));
        fraction = prevPos + segFrac * (next.pos - prevPos);
      }
      fraction = Math.min(1, Math.max(0, fraction));

      var pct = (fraction * 100).toFixed(2) + "%";

      // Anima a partir do estado inicial (largura 0 do CSS).
      requestAnimationFrame(function () {
        bar.style.width = pct;
        if (dot) {
          dot.style.left = pct;
        }
      });

      this.updateTexts(next, total);
    }

    updateTexts(next, total) {
      var promo = this.querySelector(".promotional-text");
      var congrats = this.querySelector(".congratulations-text");
      var priceToNext = this.querySelector(".price-to-next-step");
      var promotion = this.querySelector(".promotion");

      if (!next) {
        if (promo) promo.style.display = "none";
        if (congrats) congrats.style.display = "";
        return;
      }

      if (promo) promo.style.display = "";
      if (congrats) congrats.style.display = "none";

      var remaining = Math.max(0, next.threshold - total);
      if (priceToNext) {
        priceToNext.innerHTML = formatMoney(remaining);
      }
      if (promotion) {
        promotion.innerHTML = next.texto;
      }
    }
  }

  customElements.define("cart-progressbar", CartProgressbar);
})();
